import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ReconQueue } from '@/components/reconnect/ReconQueue';
import { CampaignList, RepliesList } from '@/components/reconnect/CampaignList';
import { LetterVersionsSettings } from '@/components/reconnect/LetterVersionsSettings';

export default function ReconnectPage() {
  const [tab, setTab] = useState('recon');
  return (
    <div data-testid="reconnect-page" className="p-6 lg:p-8 max-w-6xl">
      <h1 className="text-2xl font-bold text-slate-900">Reconnect with past clients</h1>
      <p className="text-sm text-slate-500 mt-1 mb-6">Look over old properties from the desk, then email past clients a free inspection offer and a link to update their details.</p>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger data-testid="reconnect-tab-recon" value="recon">Recon queue</TabsTrigger>
          <TabsTrigger data-testid="reconnect-tab-campaigns" value="campaigns">Letters &amp; campaigns</TabsTrigger>
          <TabsTrigger data-testid="reconnect-tab-replies" value="replies">Replies</TabsTrigger>
          <TabsTrigger data-testid="reconnect-tab-versions" value="versions">Letter versions</TabsTrigger>
        </TabsList>
        <TabsContent value="recon" className="mt-4"><ReconQueue /></TabsContent>
        <TabsContent value="campaigns" className="mt-4"><CampaignList /></TabsContent>
        <TabsContent value="replies" className="mt-4"><RepliesList /></TabsContent>
        <TabsContent value="versions" className="mt-4"><LetterVersionsSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
